const selection = {
  Funk: [
    {
      artist: 'Mirror People',
      name: 'Drinks Promise Better feat. Da Chick',
      slug: 'mirror-people-drinks-promise-better-feat-da-chick',
      image:
        'curatedSelection/mirror-people-drinks-promise-better-feat-da-chick.jpg',
    },
    {
      artist: 'Magoo',
      name: "Can't Get Enough",
      slug: 'magoo-can-t-get-enough',
      image: 'curatedSelection/magoo-can-t-get-enough.jpg',
    },
    {
      artist: 'Tversky',
      name: '1985 (Instrumental)',
      slug: 'tversky-1985-instrumental',
      image: 'curatedSelection/tversky-1985-instrumental.jpg',
    },
    {
      artist: 'Dj Rocca',
      name: 'Bakerys Track',
      slug: 'dj-rocca-bakerys-track',
      image: 'curatedSelection/dj-rocca-bakerys-track.jpg',
    },
  ],
  Folk: [
    {
      artist: 'Pajaro Sunrise',
      name: 'Thirty One',
      slug: 'pajaro-sunrise-thirty-one',
      image: 'curatedSelection/pajaro-sunrise-thirty-one.jpg',
    },
    {
      artist: 'Red Eye',
      name: 'All At Once',
      slug: 'red-eye-all-at-once',
      image: 'curatedSelection/red-eye-all-at-once.jpg',
    },
    {
      artist: 'Xavier Calvet',
      name: 'Honolulu',
      slug: 'xavier-calvet-honolulu',
      image: 'curatedSelection/xavier-calvet-honolulu.jpg',
    },
    {
      artist: 'Vanova',
      name: 'The Lost In Thought King',
      slug: 'vanova-the-lost-in-thought-king',
      image: 'curatedSelection/vanova-the-lost-in-thought-king.jpg',
    },
  ],
  Rock: [
    {
      artist: 'The Right Ons',
      name: 'Purple Neon Lights',
      slug: 'the-right-ons-purple-neon-lights',
      image: 'curatedSelection/the-right-ons-purple-neon-lights.jpg',
    },
    {
      artist: 'Faith and Spirit',
      name: "I'll Be Your Man",
      slug: 'faith-and-spirit-i-ll-be-your-man',
      image: 'curatedSelection/faith-and-spirit-i-ll-be-your-man.jpg',
    },
    {
      artist: 'The Lions Constellation',
      name: 'Butterflies And Flowers',
      slug: 'the-lions-constellation-butterflies-and-flowers',
      image:
        'curatedSelection/the-lions-constellation-butterflies-and-flowers.jpg',
    },
    {
      artist: 'Bullitt',
      name: 'Headblower',
      slug: 'bullitt-headblower',
      image: 'curatedSelection/bullitt-headblower.jpg',
    },
  ],
  Disco: [
    {
      artist: 'Mirror People',
      name: 'Boogie Dance feat. Hard Ton',
      slug: 'mirror-people-boogie-dance-feat-hard-ton',
      image: 'curatedSelection/mirror-people-boogie-dance-feat-hard-ton.jpg',
    },
    {
      artist: 'Francisco',
      name: 'Disco Wizzard (Space Mix)',
      slug: 'francisco-disco-wizzard-space-mix',
      image: 'curatedSelection/francisco-disco-wizzard-space-mix.jpg',
    },
    {
      artist: 'The Supermen Lovers',
      name: 'Electronic Whisper',
      slug: 'the-supermen-lovers-electronic-whisper',
      image: 'curatedSelection/the-supermen-lovers-electronic-whisper.jpg',
    },
    {
      artist: 'Panama Disco Lights',
      name: 'The Mood Iam In (Original)',
      slug: 'panama-disco-lights-the-mood-iam-in-original',
      image:
        'curatedSelection/panama-disco-lights-the-mood-iam-in-original.jpg',
    },
  ],
  Club: [
    {
      artist: 'Best Youth',
      name: 'Part Of The Noise (Xinobi Instrumental Remix)',
      slug: 'best-youth-part-of-the-noise-xinobi-instrumental-remix',
      image:
        'curatedSelection/best-youth-part-of-the-noise-xinobi-instrumental-remix.jpg',
    },
    {
      artist: 'The Elriks',
      name: 'I Am Who I Am (Edit)',
      slug: 'the-elriks-i-am-who-i-am-edit',
      image: 'curatedSelection/the-elriks-i-am-who-i-am-edit.jpg',
    },
    {
      artist: 'Da Chick',
      name: "Do The Clap (Mason's Re-Clap Remix)",
      slug: 'da-chick-do-the-clap-mason-s-re-clap-remix',
      image: 'curatedSelection/da-chick-do-the-clap-mason-s-re-clap-remix.jpg',
    },
    {
      artist: 'Marc Piñol',
      name: 'Clef III',
      slug: 'marc-pinol-clef-iii',
      image: 'curatedSelection/marc-pinol-clef-iii.jpg',
    },
  ],
  House: [
    {
      artist: 'Paredes',
      name: 'Bulletproof',
      slug: 'paredes-bulletproof',
      image: 'curatedSelection/paredes-bulletproof.jpg',
    },
    {
      artist: 'Lou Teti',
      name: 'Ditar',
      slug: 'lou-teti-ditar',
      image: 'curatedSelection/lou-teti-ditar.jpg',
    },
    {
      artist: 'Moullinex',
      name: 'Daydream (Yuksek Remix)',
      slug: 'moullinex-daydream-yuksek-remix',
      image: 'curatedSelection/moullinex-daydream-yuksek-remix.jpg',
    },
    {
      artist: 'Herr Styler',
      name: 'Gone (Original)',
      slug: 'herr-styler-gone-original',
      image: 'curatedSelection/herr-styler-gone-original.jpg',
    },
  ],
  Reggae: [
    {
      artist: 'STA',
      name: 'Sistema Nervioso',
      slug: 'sta-sistema-nervioso',
      image: 'curatedSelection/sta-sistema-nervioso.jpg',
    },
    {
      artist: 'Rickard Jäverling',
      name: 'Chasing Dub',
      slug: 'rickard-jaeverling-chasing-dub',
      image: 'curatedSelection/rickard-jaeverling-chasing-dub.jpg',
    },
    {
      artist: 'Golden Bug',
      name: 'Yama',
      slug: 'golden-bug-yama',
      image: 'curatedSelection/golden-bug-yama.jpg',
    },
    {
      artist: 'Kim',
      name: 'Racha From Aleppo',
      slug: 'kim-racha-from-aleppo',
      image: 'curatedSelection/kim-racha-from-aleppo.jpg',
    },
  ],
}

export default selection
